<template>
    <div>
        <v-row v-for="member in expanded_members" :key="member.id" no-gutters class="pa-0 mb-2">
            <v-col>
                <v-row no-gutters>
                    <v-col class="shrink">
                        <PersonAvatar :person="member" :size="24" class-name="mr-2"></PersonAvatar>
                    </v-col>
                    <v-col>
                        <span class="body-2">{{ member.name }}</span>
                        <v-icon v-if="client.default_person_id === member.id" class="ml-3" color="secondary" :size="20">
                            mdi-star
                        </v-icon>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {ref, watch} from "@vue/composition-api";
import UserModule from "@/store/modules/user";
import ClientModule from "../../store/modules/client";
import PersonAvatar from "../../components/PersonAvatar.vue";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default {
    name: "ClientUsersList",
    components: {
        PersonAvatar
    },
    props: {
        client: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const { expandClientMembers } = ClientModule();
        const userModule = UserModule();
        const expanded_members = ref([]);

        const load_data = async () => {
            try {
                await userModule.loadMembers()
                expanded_members.value = expandClientMembers(false);
            } catch (e) {
                errorDialog.showError(e)
            }
        };

        load_data();

        // When navigating via next / back buttons client wont update, and using AppModule.updateView will start to make duplicate requests.
        watch(() => props.client.id, (newVal, oldVal) => {
            if (newVal && oldVal && newVal.toString() !== oldVal.toString()) {
                load_data()
            }
        })

        return {
            expanded_members
        };
    }
};
</script>
